/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const useInviteMemberStyles = makeStyles({
  createButton: {
    textTransform: 'none',
    fontSize: '14px',
    padding: '6px 4px',
  },
  button: {
    justifyContent: 'space-between',
    paddingLeft: '15px',
    paddingRight: '12px',
    width: '240px',
  },
  buttonIcon: {
    transform: 'rotate(-90deg)',
    marginLeft: '10px',
  },
  textField: {
    margin: '0 60px',
    width: 'calc(100% - 120px)',
  },
  list: {
    padding: '0',
    margin: '8px 60px',
    maxHeight: '280px',
    overflowY: 'auto',
  },
  listItemIcon: {
    minWidth: 'auto',
    marginRight: '10px',
  },
});
